import React from 'react';
import { Link } from 'react-router-dom';

const Certifications = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <Link to="/services/skills" className="text-purple-600 hover:text-purple-700 mb-4 inline-block">
          Back to Skills Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">My Certifications</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">View and download your earned certifications</p>
          <p className="text-sm text-gray-500 mt-4">Coming soon: Certificate gallery and downloads</p>
        </div>
      </div>
    </div>
  );
};

export default Certifications;
